import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

export const router: Routes = [
    {
        path: '',
        loadChildren: 'app/pages/search-plans/search-plans.module#SearchPlansModule'
    },
    {
        path: 'minisites',
        loadChildren: 'app/pages/minisites/minisites.module#MinisitesModule'
    },
    {
        path: '**',
        loadChildren: 'app/pages/search-plans/search-plans.module#SearchPlansModule'
    },
];

export const appRouter: ModuleWithProviders = RouterModule.forRoot(router);



// WEBPACK FOOTER //
// /Users/avihayev/Phone-Plans/Lading Page/landing-page-web/src/app/app.router.ts